import { fromJS } from 'immutable';
import { LOAD_TASKS_TREE_SUCCESS, DESTROY_TASKS_TREE, APPEND_ACTIVITY_LOG } from 'constants/ActionTypes';
import { CREATE_TYPE } from 'constants/NotificationConstants';
import Immutable from 'immutable';

const initialState = fromJS({
  parentValue: null,
  paginations: {},
  datasets: {},
});

const taskTreeReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPEND_ACTIVITY_LOG: {
      const { taskId, type, entity } = action.payload;
      if (entity !== 'Task') {
        return state;
      }

      if (type !== CREATE_TYPE) {
        return state;
      }

      const { parentId } = action.payload.content.newValues;
      if (parentId !== state.get('parentValue')) {
        return state;
      }

      const pathPagination = ['paginations', parseInt(parentId)];
      if (!state.getIn(pathPagination)) {
        return state;
      }

      const pathDataset = ['datasets', parseInt(parentId)];

      return state
        .setIn(['datasets', parseInt(taskId)], Immutable.List())
        .setIn(pathDataset, state.getIn(pathDataset).push(parseInt(taskId)));
    }

    case LOAD_TASKS_TREE_SUCCESS: {
      const parentValue = action.action.payload?.successPayload?.parentValue;
      const parentId = action.action.payload.filters.parentId?.value;

      // Reinitialize state if new parentValue
      let newState = parentValue !== state.get('parentValue') ? initialState.set('parentValue', parentValue) : state;

      if (!parentId) {
        return newState;
      }

      // Prepare response data
      const dataset = fromJS(action.tasks.items.map((task) => task.taskId));
      const pagination = fromJS({
        totalCount: action.tasks._meta.totalCount,
        pageCount: action.tasks._meta.pageCount,
        currentPage: action.tasks._meta.currentPage,
        perPage: action.tasks._meta.perPage,
      });

      const pathDataset = ['datasets', parseInt(parentId)];
      const pathPagination = ['paginations', parseInt(parentId)];

      return pagination.get('currentPage') === 1
        ? newState.setIn(pathDataset, dataset).setIn(pathPagination, pagination)
        : newState.setIn(pathDataset, newState.getIn(pathDataset).merge(dataset)).setIn(pathPagination, pagination);
    }
    case DESTROY_TASKS_TREE:
      return initialState;
    default:
      return state;
  }
};

export default taskTreeReducer;
